<div class="response table-responsive m-b-2">
    <table class="est-table"cellspacing="0">
        <tbody>
            <tr>
                <td>Property Uid</td>
                <td>{{response.property_uid ? response.property_uid : '-'}}</td>
            </tr>
            <tr>
                <td>Land Value Lower Range</td>
                <td>{{response['land_value_lower_range'] || '-'}}</td>
            </tr>
            <tr>
                <td>Land Value Midpoint</td>
                <td>{{response['land_value_midpoint'] || '-'}}</td>
            </tr>
            <tr>
                <td>Land Value Higher Range</td>
                <td>{{response['land_value_higher_range'] || '-'}}</td>
            </tr>
            <tr>
                <td>Built Value Lower Range</td>
                <td>{{response['built_value_lower_range'] || '-'}}</td>
            </tr>
            <tr>
                <td>Built Value Mid Range</td>
                <td>{{response['built_value_mid_range'] || '-'}}</td>
            </tr>
            <tr>
                <td>Built Value Higher Range</td>
                <td>{{response['built_value_higher_range'] || '-'}}</td>
            </tr>
            <tr>
                <td>Property Build Year</td>
                <td>{{response['property_build_year'] || '-'}}</td>
            </tr>
            <tr>
                <td>Property Age</td>
                <td>{{response['property_age'] || '-'}}</td>
            </tr>
            <tr>
                <td>Property Name</td>
                <td>{{response['property_name'] || '-'}}</td>
            </tr>
            <tr>
                <td>Property Grade</td>
                <td>{{response['property_grade'] || '-'}}</td>
            </tr>
            <tr>
                <td>Property Category</td>
                <td>{{response['property_category'] || '-'}}</td>
            </tr>
            <tr>
                <td>Total Gla</td>
                <td>{{response['total_gla']  ? (response['total_gla'] | number : '1.0-1') : '-'}}</td>
            </tr>
            <tr>
                <td>Office Gla</td>
                <td>{{response['office_gla'] ? (response['office_gla'] | number : '1.0-1') : '-'}}</td>
            </tr>
            <tr>
                <td>Retail Gla</td>
                <td>{{response['retail_gla'] ? (response['retail_gla'] | number : '1.0-1') : '-'}}</td>
            </tr>
            <tr>
                <td>Office Rental 0-50</td>
                <td>{{response['office_rental_0_50'] || '-'}}</td>
            </tr>
            <tr>
                <td>Office Rental 50-100</td>
                <td>{{response['office_rental_50_100'] || '-'}}</td>
            </tr>
            <tr>
                <td>Office Rental 100-200</td>
                <td>{{response['office_rental_100_200'] || '-'}}</td>
            </tr>
            <tr>
                <td>Office Rental 200-300</td>
                <td>{{response['office_rental_200_300'] || '-'}}</td>
            </tr>
            <tr>
                <td>Office Rental 300-500</td>
                <td>{{response['office_rental_300_500'] || '-'}}</td>
            </tr>
            <tr>
                <td>Office Rental 500-750</td>
                <td>{{response['office_rental_500_750'] || '-'}}</td>
            </tr>
            <tr>
                <td>Office Rental 750-1000</td>
                <td>{{response['office_rental_750_1000'] ?? '-'}}</td>
            </tr>
            <tr>
                <td>Office Rental 1000+</td>
                <td>{{response['office_rental_1000+'] || '-'}}</td>
            </tr>
            <tr>
                <td>Retail Rental 0-20</td>
                <td>{{response['retail_rental_0_20'] || '-'}}</td>
            </tr>
            <tr>
                <td>Retail Rental 20-50</td>
                <td>{{response['retail_rental_20_50'] || '-'}}</td>
            </tr>
            <tr>
                <td>Retail Rental 50-100</td>
                <td>{{response['retail_rental_50_100'] || '-'}}</td>
            </tr>
            <tr>
                <td>Retail Rental 100-200</td>
                <td>{{response['retail_rental_100_200'] || '-'}}</td>
            </tr>
            <tr>
                <td>Retail Rental 200-500</td>
                <td>{{response['retail_rental_200_500'] || '-'}}</td>
            </tr>
            <tr>
                <td>Retail Rental 500-1000</td>
                <td>{{response['retail_rental_500_1000'] || '-'}}</td>
            </tr>
            <tr>
                <td>Retail Rental 1000-3000</td>
                <td>{{response['retail_rental_1000_3000'] || '-'}}</td>
            </tr>
            <tr>
                <td>Retail Rental 3000+</td>
                <td>{{response['retail_rental_3000+'] || '-'}}</td>
            </tr>
            <tr>
                <td>Name Of Highway</td>
                <td>{{response['name_of_highway'] ? response['name_of_highway'] : '-'}}</td>
            </tr>
            <tr>
                <td>Record Type Government</td>
                <td>{{response['record_type_government'] || '-'}}</td>
            </tr>
            <tr>
                <td>Record Type Estater</td>
                <td>{{response['record_type_estater'] || '-'}}</td>
            </tr>
            <tr>
                <td>Value</td>
                <td>{{response['value'] ? (response['value'] | number : '1.0-1') : '-'}}</td>
            </tr>
            <tr>
                <td>Transaction Area</td>
                <td>{{response['transaction_area'] ? (response['transaction_area'] | number : '1.0-1') : '-'}}</td>
            </tr>
            <tr>
                <td>Transaction Area Rate</td>
                <td>{{response['transaction_area_rate'] ? (response['transaction_area_rate'] | number : '1.0-1') : '-'}}</td>
            </tr>
            <tr>
                <td>Transaction Date</td>
                <td>{{response['transaction_date'] || '-'}}</td>
            </tr>
        </tbody>
    </table>

</div>